import { useEffect, useRef } from "react";

export function usePanelFocus<T extends HTMLElement>(open: boolean) {
	const panelRef = useRef<T>(null);
	const returnFocusTo = useRef<HTMLElement | null>(null);

	useEffect(() => {
		const panel = panelRef.current;
		if (!panel) return;
		if (open) {
			returnFocusTo.current = document.activeElement instanceof HTMLElement ? document.activeElement : null;
			panel.focus({ preventScroll: true });
			return;
		}
		// Tapping the backdrop blurs the panel before it closes, leaving focus on <body>.
		const active = document.activeElement;
		if (!active || active === document.body || panel.contains(active)) {
			returnFocusTo.current?.focus({ preventScroll: true });
		}
	}, [open]);

	return panelRef;
}
